
import Vue from 'vue'
import {AUTH_REQUEST_PASSWORD_RECOVERY} from '@/store/action-types'
import {PasswordRecoveryRequestPayload} from '@/types/payload'
import {Component, Watch} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {validateEmail, valueIsRequired} from '@/services/validation'
import UserDoesNotHaveAnyEmail from '@/model/error/UserDoesNotHaveAnyEmail'

@Component({})
export default class RecoveryRequestForm extends Vue {
  $refs!: {
    form: Vue & { validate(): boolean, resetValidation(): void }
  }

  private userIdentifier: string | null = null
  private isRequestInProgress: boolean = false
  private isFormValid: boolean = false
  private recoveryNotPossible: boolean = false
  private noEmailForRecovery: boolean = false
  private isRequestSuccessful: boolean = false
  private userIdentifierValidationRules: Function[] = [valueIsRequired]
  private decoded: string = atob("cG9kcG9yYUBwb3pyaW1lbnUuc2s=")
  private prefix: string = atob("bWFpbHRvOg==")

  get buttonHeight(): number | undefined {
    if (this.$vuetify.breakpoint.smAndDown) {
      return 64
    }
  }

  get showForm(): boolean {
    return !this.noEmailForRecovery && !this.recoveryNotPossible && !this.isRequestSuccessful
  }

  get showTextInstructions(): boolean {
    return this.showForm
  }

  @Action(AUTH_REQUEST_PASSWORD_RECOVERY) requestPasswordRecovery!: { (payload: PasswordRecoveryRequestPayload): Promise<void> }

  resetState(): void {
    this.isRequestSuccessful = false
    this.noEmailForRecovery = false
    this.recoveryNotPossible = false
  }

  async onFormSubmit(): Promise<void> {
    if (this.$refs.form.validate()) {
      this.resetState()

      this.isRequestInProgress = true

      try {
        const payload: PasswordRecoveryRequestPayload = {
          loginName: validateEmail(this.userIdentifier!) !== true ? this.userIdentifier : null,
          email:  validateEmail(this.userIdentifier!) === true ? this.userIdentifier : null
        }

        await this.requestPasswordRecovery(payload)

        this.isRequestSuccessful = true
      } catch (e) {
        if (e instanceof UserDoesNotHaveAnyEmail) {
          this.noEmailForRecovery = true
        } else {
          this.recoveryNotPossible = true
        }
      } finally {
        this.isRequestInProgress = false
      }
    }
  }

  onAcknowledgeButtonClick(): void {
    this.$router.replace({name: 'Login'})
  }

  onRepeatButtonClick(): void {
    this.resetState()
  }
}
